import React from 'react';
import { NavLink } from 'react-router-dom';
import BasketNavIcon from './graphics/NavIcons/BasketNavIcon';
import OrdersNavIcon from './graphics/NavIcons/OrdersNavIcon';
import HomeNavIcon from './graphics/NavIcons/HomeNavIcon';
import ProfileNavIcon from './graphics/NavIcons/ProfileNavIcon';
import HelpNavIcon from './graphics/NavIcons/HelpNavIcon';

/**
 * assembles nav icon with react router link functionality
 *
 * @param { string } destination url or path to redirect to
 * @param { string } text text to place underneath icon
 * @param { React.Component } Icon icon to be displayed as content
 */
function NavIcon({ destination, text, Icon, href }) {
  return (
    <NavLink exact href={href} to={destination} activeClassName="active" className="u-text-center">
      <Icon />
      <span>{text ? text.toUpperCase() : null}</span>
    </NavLink>
  );
}

/**
 * assembles nav icon with as a direct url link
 *
 * @param { string } text text to place underneath icon
 * @param { React.Component } Icon icon to be displayed as content
 * @param { string } href url to redirect to
 *
 */
function ExternalNavIcon({ text, Icon, href }) {
  return (
    <a href={href} rel="noreferrer noopener" target="_blank" className="u-text-center">
      <Icon />
      <span>{text ? text.toUpperCase() : null}</span>
    </a>
  );
}

/**
 * footer navigation bar
 */
function IconNavBar() {
  return (
    <div className="c-icon-nav u-black-bg">
      <nav>
        <NavIcon destination="/basket" text="basket" Icon={BasketNavIcon} />
        <NavIcon destination="/orders" text="orders" Icon={OrdersNavIcon} />
        <NavIcon destination="/" text="home" Icon={HomeNavIcon} />
        <NavIcon destination="/account" text="profile" Icon={ProfileNavIcon} />
        <ExternalNavIcon text="help" Icon={HelpNavIcon} href="http://help.sofology.co.uk" />
      </nav>
    </div>
  );
}

export default IconNavBar;



// WEBPACK FOOTER //
// ./src/layout/IconNavBar.js